export default __webpack_public_path__ + "static/media/masonbee.a67b90f1.jpg";